import Client from './client.service';
import { otherProjects } from '@config/config';

class OtherProjects extends Client {
  static path = otherProjects;

  static url = (path) => {
    return this.api_url + this.api_url_prefix + path;
  };

  static get_other_projects = async (page = 1, pagesize = 100, params = {}) => {
    const url = `${this.url(this.path.LIST)}?${this._query_string({ page, pagesize, ...params })}`;
    return this._fetch(url);
  };

  static get_other_project = async (
    slug,
    page = 1,
    pagesize = 100,
    params = {},
  ) => {
    const url = `${this.url(this.path.GET)}?${this._query_string({ slug, page, pagesize, ...params })}`;
    return this._fetch(url);
  };
}

export default OtherProjects;
